// Resolves after `ms` even if `promise` is still pending, so a slow step can't block the update.
const settleWithin = (promise, ms) =>
  Promise.race([promise, new Promise((resolve) => setTimeout(resolve, ms))]).catch(() => {});

export const UpdateSystem = {
  data: () => ({
    isUpdating: false,
  }),
  methods: {
    async updateNow() {
      if (this.isUpdating) return;
      this.isUpdating = true;

      // unregister() is queued behind any in-progress service worker install and only
      // resolves after precaching finishes, so it is started but never awaited.
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => registrations.forEach((reg) => reg.unregister()))
          .catch(() => {});
      }

      // With the caches gone, the still-active worker misses its precache and falls back
      // to the network, so the reload gets the new index.html and bundles.
      if ('caches' in window) {
        await settleWithin(
          caches.keys().then((names) => Promise.all(names.map((name) => caches.delete(name)))),
          1500
        );
      }

      this.$global.TriggerRefresh();
    }
  }
};
